import React from 'react';
import GalleryItem from './GalleryItem';
import type { GalleryImage } from '../../hooks/useGallery';

interface GalleryGridProps {
  images: GalleryImage[];
  onImageClick?: (image: GalleryImage) => void;
}

const GalleryGrid: React.FC<GalleryGridProps> = ({ images, onImageClick }) => {
  if (images.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No images found in the gallery.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {images.map((image) => (
        <GalleryItem 
          key={image.id} 
          image={image} 
          onClick={() => onImageClick && onImageClick(image)} 
        />
      ))}
    </div>
  );
};

export default GalleryGrid;